export const SET_TASK = 'TASK_FLIGHT_BLOCK/SET_TASK'
export const SET_TASKS = 'TASK_FLIGHT_BLOCK/SET_TASKS'
export const SET_CONTACTS = 'TASK_FLIGHT_BLOCK/SET_CONTACTS'
